module.exports = __webpack_public_path__ + "static/2024-feeding-greatness-978909dfaf875b7725b11ba3bb06310e.png";